import { createFileRoute } from '@tanstack/react-router';
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import styled from 'styled-components';
import api from '@/api';
import type { components } from '@/api/qraft/schema';
import { PageTitle } from '~/components/ui/Page';
import { Table } from '~/components/ui/Table';

export const Route = createFileRoute('/_admin/onboardings/')({
  component: OnboardingsList,
});

type OnboardingSequenceItem = components['schemas']['OnboardingSequenceItem'];

const columnHelper = createColumnHelper<OnboardingSequenceItem>();

const columns = [
  columnHelper.accessor('id', { header: 'ID' }),
  columnHelper.accessor('language', { header: 'Language' }),
  columnHelper.accessor((row) => row.activation_condition ?? '—', {
    id: 'activation_condition',
    header: 'Activation Condition',
  }),
  columnHelper.accessor('slide_count', { header: 'Slides' }),
];

function OnboardingsList() {
  const { data, isLoading, error } = api.listOnboardingSequences.useQuery();

  const table = useReactTable({
    data: data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <PageTitle>Onboardings</PageTitle>
      {isLoading ? (
        <Message>Loading onboardings...</Message>
      ) : error ? (
        <Message $error>Error loading onboardings</Message>
      ) : (
        <Table
          table={table}
          to="/onboardings/$onboardingId"
          getParams={(row) => ({ onboardingId: String(row.id) })}
        />
      )}
    </div>
  );
}

const Message = styled.div<{ $error?: boolean }>`
  padding: 2rem;
  text-align: center;
  color: ${(p) => (p.$error ? 'var(--error)' : 'var(--grey-600)')};
`;
